var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.searchingConfig } }, [
    _c(
      "form",
      { attrs: { autocomplete: "off", "data-vv-scope": "flow-part-1" } },
      [
        _c("div", { staticClass: "row mb-3" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h4", [_vm._v("Datos para el flujo")]),
            _vm.wizardData.fileCategory === "numInt" ||
            _vm.wizardData.fileCategory === "numOf"
              ? _c("span", [
                  _vm._v(" Este expediente "),
                  _vm.wizardData.fileCategory === "numInt"
                    ? _c("span", [_vm._v(" podrá tener numeración interna ")])
                    : _vm._e(),
                  _vm.wizardData.fileCategory === "numOf"
                    ? _c("span", [
                        _vm._v(" podrá ser tramitado por Oficina de Partes ")
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label: "Nombre para el flujo (*)",
                  maxlength: "120",
                  name: "name",
                  danger: _vm.errors.has("flow-part-1.name"),
                  "danger-text": _vm.errors.first("flow-part-1.name")
                },
                model: {
                  value: _vm.step.name,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "name", $$v)
                  },
                  expression: "step.name"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label: "Resumen (*)",
                  name: "description",
                  danger: _vm.errors.has("flow-part-1.description"),
                  "danger-text": _vm.errors.first("flow-part-1.description"),
                  maxlength: "550"
                },
                model: {
                  value: _vm.step.description,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "description", $$v)
                  },
                  expression: "step.description"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-6 mt-3" },
            [
              _c("BooleanParameter", {
                attrs: {
                  "is-approval-sign": true,
                  disabled: _vm.disableSignaturePosition,
                  "param-id": "aprobaciones.firmas.ubicacion",
                  "default-false": "",
                  "data-cy": "setSignaturePosition"
                },
                on: { input: _vm.onSetSignaturePositionChange },
                model: {
                  value: _vm.step.setSignaturePosition,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "setSignaturePosition", $$v)
                  },
                  expression: "step.setSignaturePosition"
                }
              })
            ],
            1
          ),
          _vm.documentHasOficeActions
            ? _c(
                "div",
                { staticClass: "col-md-6 col-xs-12 col-sm-12 mt-3" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Oficina de partes que numera (*)" } },
                    [
                      _c(
                        "v-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            "data-vv-as": "oficina que numera",
                            name: "numerationOffice",
                            danger: _vm.errors.has(
                              "flow-part-1.numerationOffice"
                            ),
                            "danger-text": _vm.errors.first(
                              "flow-part-1.numerationOffice"
                            ),
                            disabled: _vm.step.office.list.length === 1,
                            options: _vm.step.office.list,
                            placeholder: "Selecciona una oficina"
                          },
                          on: { input: _vm.selectNumerationOffice },
                          model: {
                            value: _vm.step.office.selected,
                            callback: function($$v) {
                              _vm.$set(_vm.step.office, "selected", $$v)
                            },
                            expression: "step.office.selected"
                          }
                        },
                        [
                          _c("template", { slot: "no-options" }, [
                            _vm._v(
                              " no hay tipos de documentos para el criterio de búsqueda "
                            )
                          ])
                        ],
                        2
                      ),
                      _vm.errors.has("flow-part-1.numerationOffice")
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "flow-part-1.numerationOffice"
                                  ) || ""
                                ) +
                                " "
                            )
                          ])
                        : _vm._e(),
                      _vm._l(_vm.step.actions, function(action, $index) {
                        return _c(
                          "span",
                          {
                            key: $index + "-action",
                            staticClass: "badge badge-primary ml-3"
                          },
                          [_vm._v(" " + _vm._s(action.action) + " ")]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]
    ),
    _c("form", { attrs: { "data-vv-scope": "flow-part-2" } }, [
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h4", [_vm._v("Detalle del flujo")]),
          _c("small", { staticClass: "text-primary" }, [
            _vm._v(
              " Este documento debe ser tramitado por una oficina, pero no te preocupes, se colocará automáticamente "
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "row mb-5" }, [
        _c(
          "div",
          { staticClass: "col-3" },
          [
            _c(
              "vs-select",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label: "Tipo de paso (*)",
                  name: "stepType",
                  autocomplete: "",
                  danger: _vm.errors.has("flow-part-2.stepType"),
                  "danger-text": _vm.errors.first("flow-part-2.stepType")
                },
                on: { change: _vm.searchOffice },
                model: {
                  value: _vm.stepType,
                  callback: function($$v) {
                    _vm.stepType = $$v
                  },
                  expression: "stepType"
                }
              },
              [
                _c("vs-select-item", {
                  attrs: { value: _vm.stepTypes.USER, text: "Usuario" }
                }),
                !_vm.documentHasOficeActions &&
                _vm.wizardData.fileCategory !== "int"
                  ? _c("vs-select-item", {
                      attrs: { value: _vm.stepTypes.OFFICE, text: "Oficina" }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm.stepType === _vm.stepTypes.OFFICE
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("list-offices", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required: _vm.stepType === this.stepTypes.OFFICE
                      },
                      expression:
                        "{ required: stepType === this.stepTypes.OFFICE }"
                    }
                  ],
                  ref: "groupStep",
                  staticClass: "w-100 mb-1",
                  attrs: {
                    autocomplete: "",
                    label: "Oficina del responsable (*)",
                    name: "groupStep",
                    "data-vv-as": "oficina",
                    typeList: _vm.stepType,
                    "validate-lider": "",
                    withFilters: "",
                    officeType: _vm.wizardData.fileCategory,
                    danger: _vm.errors.has("flow-part-2.groupStep"),
                    "danger-text": _vm.errors.first("flow-part-2.groupStep")
                  },
                  model: {
                    value: _vm.groupStep,
                    callback: function($$v) {
                      _vm.groupStep = $$v
                    },
                    expression: "groupStep"
                  }
                }),
                _c("small", { staticClass: "text-danger" }, [
                  _vm._v(
                    " Si le falta una oficina, favor notificar al equipo de Soporte para que verifiquen que esté correctamente configurada "
                  )
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.stepType === _vm.stepTypes.USER
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("list-user", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: _vm.stepType === _vm.stepTypes.USER },
                      expression: "{ required: stepType === stepTypes.USER }"
                    }
                  ],
                  ref: "userStep",
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Usuario (*)",
                    name: "userStep",
                    withFilters: "",
                    danger: _vm.errors.has("flow-part-2.userStep"),
                    "danger-text": _vm.errors.first("flow-part-2.userStep")
                  },
                  model: {
                    value: _vm.userStep,
                    callback: function($$v) {
                      _vm.userStep = $$v
                    },
                    expression: "userStep"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.stepType !== _vm.stepTypes.OFFICE
          ? _c(
              "div",
              { staticClass: "col-3" },
              [
                _c(
                  "vs-select",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      label: "Tipo de rol (*)",
                      name: "rolType",
                      autocomplete: "",
                      danger: _vm.errors.has("flow-part-2.rolType"),
                      "danger-text": _vm.errors.first("flow-part-2.rolType")
                    },
                    model: {
                      value: _vm.rolType,
                      callback: function($$v) {
                        _vm.rolType = $$v
                      },
                      expression: "rolType"
                    }
                  },
                  [
                    _c("vs-select-item", {
                      attrs: { value: _vm.rolTypes.APPROVER, text: "Aprobador" }
                    }),
                    _c("vs-select-item", {
                      attrs: { value: _vm.rolTypes.VIEWER, text: "Visador" }
                    }),
                    _c("vs-select-item", {
                      attrs: { value: _vm.rolTypes.SIGNER, text: "Firmante" }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _vm._v(" info "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-icon rounded-circle mt-1",
                        attrs: {
                          size: "sm",
                          id: "popover-button-default",
                          variant: "flat-primary"
                        }
                      },
                      [_c("feather-icon", { attrs: { icon: "InfoIcon" } })],
                      1
                    ),
                    _c("InfoRolType")
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.stepType === _vm.stepTypes.OFFICE
          ? _c(
              "div",
              { staticClass: "col-3" },
              [
                _c(
                  "vs-select",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "",
                      label: "Tipo de rol",
                      name: "rolType",
                      danger: _vm.errors.has("flow-part-2.rolType"),
                      "danger-text": _vm.errors.first("flow-part-2.rolType")
                    },
                    model: {
                      value: _vm.rolType,
                      callback: function($$v) {
                        _vm.rolType = $$v
                      },
                      expression: "rolType"
                    }
                  },
                  [
                    _c("vs-select-item", {
                      attrs: {
                        value: _vm.rolTypes.SIGNER,
                        text: "Numerar/Tramitar"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _vm._v(" info "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-icon rounded-circle mt-1",
                        attrs: {
                          size: "sm",
                          id: "popover-button-default",
                          variant: "flat-primary"
                        }
                      },
                      [_c("feather-icon", { attrs: { icon: "InfoIcon" } })],
                      1
                    ),
                    _c(
                      "b-popover",
                      {
                        attrs: {
                          target: "popover-button-default",
                          triggers: "focus",
                          placement: "top"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "title",
                              fn: function() {
                                return [_c("span", [_vm._v("Tipos de roles!")])]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          2187985360
                        )
                      },
                      [
                        _c("span", [
                          _c("b", [_vm._v("+ Firmante:")]),
                          _vm._v(
                            " Permite firmar documentos, esto cuenta como la aprobación. "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12 d-flex align-items-end justify-content-end" },
          [
            _c(
              "vs-button",
              {
                attrs: {
                  color: "primary",
                  icon: "add",
                  disabled: _vm.blockButton,
                  "data-cy": "add-step"
                },
                on: {
                  click: function($event) {
                    return _vm.addStep()
                  }
                }
              },
              [_vm._v(" Agregar Paso ")]
            )
          ],
          1
        )
      ]),
      _vm.step.steps.length
        ? _c(
            "div",
            { staticClass: "row mb-3" },
            _vm._l(_vm.step.steps, function(step, index) {
              return _c("div", { key: "step-" + index, staticClass: "col-3" }, [
                _c("div", { staticClass: "step-wrapper" }, [
                  _c("span", { staticClass: "step-number" }, [
                    _vm._v(_vm._s(step.stepNumber))
                  ]),
                  _c(
                    "span",
                    { staticClass: "step-delete" },
                    [
                      _c("vs-icon", {
                        attrs: {
                          icon: "highlight_off",
                          size: "small",
                          bg: "white",
                          round: ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeStep(step)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "text-center step-name" }, [
                    _vm._v(" " + _vm._s(step.responsibleName) + " ")
                  ]),
                  _c("div", { staticClass: "step-type" }, [
                    step.stepType === _vm.stepTypes.USER
                      ? _c("span", [_vm._v(" usuario ")])
                      : _vm._e(),
                    step.stepType === _vm.stepTypes.OFFICE
                      ? _c("span", [_vm._v(" oficina ")])
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "step-rol" }, [
                    step.rolType === _vm.rolTypes.APPROVER
                      ? _c("span", [_vm._v(" aprobador ")])
                      : _vm._e(),
                    step.stepType !== _vm.stepTypes.OFFICE &&
                    step.rolType === _vm.rolTypes.SIGNER
                      ? _c("span", [_vm._v(" firmante ")])
                      : _vm._e(),
                    step.rolType === _vm.rolTypes.VIEWER
                      ? _c("span", [_vm._v(" visador ")])
                      : _vm._e(),
                    step.stepType === _vm.stepTypes.OFFICE &&
                    step.rolType === _vm.rolTypes.SIGNER
                      ? _c("span", [_vm._v(" num/tramitar ")])
                      : _vm._e()
                  ])
                ])
              ])
            }),
            0
          )
        : _vm._e(),
      _vm.error.message !== ""
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to text-right",
              staticStyle: { height: "32px" }
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.error.message) + " ")
              ])
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }